<script>
import {Carousel3d, Slide} from '../../../node_modules/vue-carousel-3d';

export default {
  props: {
    perspective: 1
  },
  methods: {
    onAfterSlideChange(index) {

      let extensionList = document.querySelectorAll('[data-slide-extension="'+this.$attrs.id+'"]')

      if (extensionList.length > 0) {
        extensionList.forEach((el) => {
          if (parseInt(el.dataset.slideIndex) === index) {
            el.classList.remove('is-hidden');
          } else {
            el.classList.add('is-hidden');
          }
        })
      }
    },
  },
  components: {
    Carousel3d,
    Slide
  }
};
</script>
